module.exports = __webpack_public_path__ + "img/error.95cfcbe6.png";